import $ from 'jquery';
import Gallery from "blueimp-gallery";

// BlueImp Gallery click
const onBlueimpGalleryLinkClick = (e) => {
  e.preventDefault();
  let blueimpLinks = document.querySelectorAll('[data-gallery]');  
  let selector = e.currentTarget.getAttribute('data-gallery');
  // console.log("blueimp gallery selector", selector)
  if (!selector) {
    return
  }
  let link = e.currentTarget;
  let options = {
    container: selector,
    event: e,
    index: link,
    titleElement: 'header',
    onslide: (index) => {
      // add download link to full image title
      const list = [...document.querySelectorAll('a[data-gallery="' + selector + '"]')]
      const currentLink = list.length > index ? list[index] : null
      if (currentLink && currentLink.dataset.download) {
        const gallery = document.querySelector(selector)
        const title = gallery ? gallery.querySelector(".title") : null
        let html = currentLink.title ? currentLink.title : "";
        html += currentLink.dataset.download
        console.log(selector, gallery, title, html)
        if (title) {
          title.innerHTML = html
        }
      }
    },
  }
  Gallery(blueimpLinks, options);
}
// allow HTML in image title
const blueImpTitleHtmlFIX = () => {
  $.extend(Gallery.prototype, {
    setTitle: function (index) {
      var firstChild = this.slides[index].firstChild
      var text = firstChild.title || firstChild.alt
      var titleElement = this.titleElement
      if (titleElement.length) {
        this.titleElement.empty()
        if (text) {
          // titleElement[0].appendChild(document.createTextNode(text))
          (titleElement[0]).innerHTML = text
        }
      }
    },
  })
}

export const blueimpGalleryDestroy = () => {
  document.body.style.overflow = "visible"
}

// ### INIT
export const initCommon = () => {
  $('body').on('click', 'a[data-gallery]', onBlueimpGalleryLinkClick);
  blueImpTitleHtmlFIX()
};

